// extracted by mini-css-extract-plugin
export default {"section":"NPATab_section__lMgiX","title":"NPATab_title__fqxQY"};